.button {
  all: unset;
  cursor: pointer;
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  border-radius: var(--border-radius-lg);
  color: var(--color-black-1);
  font-weight: var(--font-weight--semibold);
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-items: center;
}

.button:disabled {
  cursor: not-allowed;
  background-image: none;
  background-color: rgba(204, 204, 204, 0.5);
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
  box-shadow: none;
}

.button:focus-visible {
  outline: 3px solid var(--color-active-3);
  outline-offset: 2px;
}

.left {
  display: flex;
  justify-self: start;
}

.right {
  display: flex;
  justify-self: end;
}

.shinyGold {
  background: #fcd469;
  border: 2px solid white;
}

.dimGold {
  background-image: linear-gradient(to right, var(--color-beige-3), var(--color-beige-2));
}

.purple {
  color: var(--text-primary);
  background: var(--color-active-2);
}

.transparent {
  border: 3px solid var(--color-beige-3);
  color: var(--text-primary);
}

.white {
  color: var(--color-black-1);
  background-color: var(--text-primary);
}

.white:disabled {
  color: var(--color-black-4);
}

.text {
  color: var(--text-primary);
  box-shadow: none;
  text-decoration: underline;
}
